export default "__VITE_ASSET__p1n2W$op__"